import { RouteRecordRaw } from 'vue-router';

const ideaRoutes: Array<RouteRecordRaw> = [
  {
    path: '',
    component: () => import('@/app/idea-voter/components/ideas-index.vue'),
    children: [
      {
        path: 'ideas/list',
        component: () =>
          import('@/app/idea-voter/components/ideas-list-component.vue'),
        name: 'app.ideas.list',
      },
      {
        path: 'ideas/my-ideas',
        component: () =>
          import('@/app/idea-voter/components/ideas-my-ideas-component.vue'),
        name: 'app.ideas.my-ideas',
      },
      {
        path: 'ideas/approve_ideas',
        component: () =>
          import(
            '@/app/idea-voter/components/ideas-waiting-to-approve-ideas-component.vue'
          ),
        name: 'app.ideas.approve_ideas',
      },
      {
        path: 'ideas/archived',
        component: () =>
          import('@/app/idea-voter/components/archived-ideas-component.vue'),
        name: 'app.ideas.archived',
      },
    ],
  },
];

export default ideaRoutes;
